import React from 'react'
import { useHistory, Link } from 'react-router-dom'
import { Menu } from 'antd'

import Confirm from './components/NoticeModal'
import { sidebarData } from './config'
import message from '../components/Message'
import './DetailPageSidebar.styl'

const DetailPageSidebar = ({ defaultOption, allow, prevUrl, level1 }) => {
    const history = useHistory()
    const prevList = {
        个人开户: {
            title: '职工开户须知',
            detail:
                '按照《住房公积金管理条例》等相关规定，单位录用职工的，应当自录用之日起30日内为尚未设立个人住房公积金账户的职工办理账户设立手续。本单位承诺按公积金业务规定办理，若因本单位未按规定办理个人账户设立而造成任何后果，由本单位承担相应的责任。\n\n',
        },

        启封: {
            title: '职工启封须知',
            detail:
                '按照《住房公积金管理条例》等相关规定，单位要为处于停缴状态的个人汇缴住房公积金的，需进行启封操作。本单位承诺按公积金业务规定办理，若因本单位未按规定办理个人账户启封而造成任何后果，由本单位承担相应的责任。\n\n',
        },

        转入: {
            title: '职工转入须知',
            detail:
                '按照《住房公积金管理条例》等相关规定，住房公积金账户在“上海市公积金管理中心住房公积金集中封存专户”的个人被单位录用后，单位应办理账户转移手续。本单位承诺按公积金业务规定办理，若因本单位未按规定办理个人账户转移而造成任何后果，由本单位承担相应的责任。\n\n',
        },

        转出: {
            title: '职工转出须知',
            detail:
                '按照《住房公积金管理条例》等相关规定，个人与原单位终止劳动关系后即被新单位录用的，原单位应当自劳动关系终止之日起30日内，将个人住房公积金账户转移到新单位。本单位承诺按公积金业务规定办理，若因本单位未按规定办理个人账户转移而造成任何后果，由本单位承担相应的责任。\n\n',
        },

        封存: {
            title: '住房公积金账户网上集中封存业务办理须知',
            detail:
                '1、按照《住房公积金管理条例》等相关规定，个人与单位终止劳动关系，尚未重新就业的，个人住房公积金账户所在单位应当自劳动关系终止之日起30日内为个人住房公积金账户办理封存手续；个人住房公积金账户所在单位因合并、分立而终止、注销或单位撤销、解散、破产，个人尚未重新就业的，单位或清算组织应当在单位终止或注销前为个人住房公积金账户办理封存手续。\n2、单位已经知悉并承诺遵守上海市公积金管理中心关于住房公积金账户集中封存业务办理的规定。如果发生变化，愿按新的规定执行。\n3、单位根据住房公积金账户集中封存业务办理的规定，通过上海住房公积金网单位公积金网上业务办理系统为职工办理住房公积金账户集中封存业务。单位可在线办理封存原因为终止劳动关系的封存业务。\n4、单位登陆上海住房公积金网单位公积金网上业务办理系统操作的一切业务办理行为视为单位行为。\n5、单位提供的所有材料及信息应真实、准确、有效，并承担因材料虚假、信息错误所引发的责任。\n6、单位办理网上集中封存业务的，应规范为职工缴存住房公积金，不能出现欠缴行为。若经查实未为职工规范缴存住房公积金，将取消单位集中封存网上业务办理资格。\n7、单位网上申报的退工信息与单位至网点办理集中封存提供的退工信息效力一致，均是单位有效行为，单位应准确申报相关信息。\n8、单位为职工账户办理集中封存业务前，应事先告知职工本人其账户封存事实。若因单位未准确申报信息并及时为职工办理住房公积金账户集中封存而造成任何后果的，由该单位承担相应的责任。\n9、由于不可抗力或非市公积金管理中心原因导致无法正常进行集中封存网上业务操作，市公积金管理中心不承担责任。\n10、单位对本项业务中任何情况如有疑问的，可以拨打12329住房公积金热线咨询或至管理部咨询。\n\n',
        },

        待转出停缴: {
            title: '待转出停缴须知',
            detail:
                '按照《住房公积金管理条例》等相关规定，单位与个人终止劳动关系的，单位应及时为个人办理账户转出到录用单位或封存手续。\n个人工作变动至新单位，因原单位尚未获得新单位账号而使得个人账户暂时停留在原单位尚未转移的，原单位为确保及时、准确办理汇缴，需要暂时停止该个人账户缴存的，停缴期限按月设置，自停缴审核通过之日的次月起计算，停缴期限不超过六个月。停缴期限到期后，原单位不得再次就此原因申请同一账户停缴。在停缴期限内，单位应及时办理个人账户转移手续，若超过停缴期限仍未办理的，账户自动恢复正常缴存。\n单位账户联系人、联系电话、联系地址等信息发生变动时，单位应及时办理变更手续，确保及时收到个人账户变动提示等相关通知。\n若因本单位未及时为个人办理账户转出或封存而造成任何后果，由本单位承担相应的责任。\n\n',
        },

        待销户停缴: {
            title: '待销户停缴须知',
            detail:
                '按照《住房公积金管理条例》等相关规定，单位与个人终止劳动关系的，单位应及时为个人办理账户转出到录用单位或封存手续。个人符合销户条件时，应及时通知个人办理销户提取手续。\n若因本单位未及时通知个人办理销户提取手续而造成任何后果，由本单位承担相应的责任。\n\n',
        },
    }
    const LinkTo = (name) => {
        prevList[name] &&
            Confirm({
                title: prevList[name]?.title,
                detail: prevList[name]?.detail,
                url: prevUrl,
                history,
            })
    }
    const onTipForbidden = (e) => {
        const className = e.target?.className || ''
        if (className.indexOf('ant-menu ant-menu-sub') !== -1) {
            message.error('请根据任务说明完成“' + allow + '”')
        }
    }

    return (
        <div className="gjj-page-sidebar scrollbar" onClick={onTipForbidden}>
            <Menu
                mode="inline"
                key={defaultOption.key}
                defaultOpenKeys={[defaultOption.open]}
                defaultSelectedKeys={[defaultOption.selected]}
            >
                {sidebarData.map((l1) => {
                    return (
                        <Menu.SubMenu
                            key={l1.name}
                            title={l1.name}
                            className={`${l1.children ? '' : 'no-children'}`}
                            icon={<img className="item-icon" style={{ width: '40px' }} src={l1.icon} />}
                        >
                            {l1.children?.map((l2) => (
                                <Menu.Item
                                    key={l2.name}
                                    disabled={
                                        allow === '增员办理'
                                            ? l2.allow !== allow
                                            : allow === '批量开户'
                                            ? l2.batch !== allow
                                            : l2.reduce !== allow
                                    }
                                >
                                    <Link
                                        className="item-link"
                                        onClick={() => LinkTo(l2.name)}
                                        to={`${prevUrl}/${l2.name}`}
                                    >
                                        {l2.name}
                                    </Link>
                                </Menu.Item>
                            ))}
                        </Menu.SubMenu>
                    )
                })}
            </Menu>
        </div>
    )
}

export default DetailPageSidebar
